import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { BgIconPrefixStyled } from "./styled";

const BgIconPrefix = ({
  theme_stadard_btn,
  theme_add,
  theme_cancel,
  theme_border_50,
  theme_background_transparent,
  theme_white_purple,
  type = "button",
  label,
  onClick,
  disabled,
  color,
  icon,
  height,
}) => {
  const customClass = cx({
    theme_stadard_btn: theme_stadard_btn,
    theme_add: theme_add,
    theme_cancel: theme_cancel,
    theme_border_50: theme_border_50,
    theme_background_transparent: theme_background_transparent,
    theme_white_purple: theme_white_purple,
  });
  return (
    <BgIconPrefixStyled disabled={disabled} color={color} height={height}>
      <div className={customClass}>
        <button
          type={type}
          disabled={disabled}
          className="btn"
          onClick={onClick}
        >
          {icon}
          {label}
        </button>
      </div>
    </BgIconPrefixStyled>
  );
};

BgIconPrefix.propTypes = {};

export default BgIconPrefix;
